import './index.scss'
import React, { useState, useEffect } from 'react';
import { get, post } from '../../util/request';
import { useTranslation } from 'react-i18next';
import { Pagination } from 'antd';
import { useSelector } from 'react-redux';
import { userInfo } from '../../redux/slice';
import Loading from '../../components/common/loading.js';
import { useHistory } from 'react-router';
import SortOrFilterBox from '../login-as/sort-filter-box/index.js';

export default LoginAs; function LoginAs() {
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const [loading, setLoading] = useState(false);
    const [pageNum, setPageNum] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [activeClients, setActiveClients] = useState([]);
    const [filterOption, setFilterOption] = useState([]);
    const [showNotif, setShowNotif] = useState({ filter: false, sort: false, filterValue: '', sortValue: '' });
    const [listParams, setListParams] = useState({ keywords: '', region: '', sort: '' });
    const history = useHistory();

    const sortOption = [
        { value: 'clientId,ASC', label: t('Client ID') + ' (A-Z)' },
        { value: 'clientId,DESC', label: t('Client ID') + ' (Z-A)' },
        { value: 'UserName,ASC', label: t('Username') + ' (A-Z)' },
        { value: 'UserName,DESC', label: t('Username') + ' (Z-A)' },
        { value: 'FullName,ASC', label: t('Full name') + ' (A-Z)' },
        { value: 'FullName,DESC', label: t('Full name') + ' (Z-A)' },
        { value: 'Region,ASC', label: t('Region') + ' (A-Z)' },
        { value: 'Region,DESC', label: t('Region') + ' (Z-A)' },
        { value: 'AccountManager,ASC', label: t('Account Manager') + ' (A-Z)' },
        { value: 'AccountManager,DESC', label: t('Account Manager') + ' (Z-A)' }
    ];

    const filterList = async () => {
        let params = {
            userId: user.userId,
            accessToken: user.accessToken
        };
        const data = await get('/loginAs/region', params);
        if (data) {
            setFilterOption(data.map(item => ({
                ...item,
                value: item.regionCode,
                label: item.region
            })));
        }
    }

    const handleClear = async () => {
        setListParams(prevData => ({
            ...prevData,
            keywords: ''
        }));

        setPageSize(10);
        setPageNum(0);
        clients({
            keywords: '',
            region: listParams.region,
            sort: listParams.sort
        });
    }

    const handleKeyDown = async (e) => {
        if (e.keyCode === 13) {
            clients(listParams);
        }
    }

    const handleSearchChange = async (value) => {
        setListParams(prevData => ({
            ...prevData,
            keywords: value
        }));
    }

    useEffect(() => {
        sessionStorage.removeItem('previewDetail');
        clients(listParams);
        filterList();
    }, []);

    useEffect(() => {
        clients(listParams);
    }, [pageNum, pageSize]);

    const clients = async (search) => {
        setLoading(true);
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        let params = {
            size: pageSize,
            page: pageNum > 0 ? pageNum - 1 : 0,
            userId: user.userId,
            accessToken: user.accessToken,
            keywords: search.keywords,
            region: search.region,
            sort: search.sort
        };

        const data = await get('/loginAs', params);

        if (data) {
            setActiveClients(data.content);
            setTotal(data.totalElements);
        }

        setLoading(false);
    }

    const preview = async (item) => {
        setLoading(true);
        let params = {
            userId: user.userId,
            accessToken: user.accessToken
        };
        const data = await post('/loginAs/preview/' + item.clientId, params);

        if (data.message === 'Success') {
            sessionStorage.setItem('previewDetail', JSON.stringify(item));
            localStorage.setItem('banner_status', '');
            localStorage.setItem('banner_status_jp', '');
            history.push({
                pathname: '/preview/home'
            });
        }
        else {
            sessionStorage.removeItem('previewDetail');
        }
        setLoading(false);
    }

    const showNotification = (type) => {
        if (type === 'Filter') {
            setShowNotif(prevData => ({
                ...prevData,
                filter: type === 'Filter' ? !prevData.filter : prevData.filter,
                sort: false
            }));
        }
        else {
            setShowNotif(prevData => ({
                ...prevData,
                filter: false,
                sort: type === 'Sort' ? !prevData.sort : prevData.sort
            }));
        }
    }

    const filterApply = async (data) => {
        setListParams(prevData => ({
            ...prevData,
            region: data
        }));
        clients({
            keywords: listParams.keywords,
            region: data,
            sort: listParams.sort
        });
        showNotification('Filter');
    }

    const sortApply = async (data) => {
        setListParams(prevData => ({
            ...prevData,
            sort: data
        }));

        clients({
            keywords: listParams.keywords,
            region: listParams.region,
            sort: data
        });
        showNotification('Sort');
    }

    return (<>
        {loading ? <Loading /> : null}
        <div className="login-as">
            <div className="main-box">
                <div className="headline login-as-wrapper">
                    <div className='col-md-4 login-as-title'><p>{t('View Clients')}</p></div>
                    <div className='col-md-8 login-as-header'></div>
                </div>
                <div className='submit-box login-as-container'>
                    <div className='login-as-search'>
                        <input type='text' className='form-control' value={listParams.keywords} placeholder={t("Keywords")} onKeyDown={handleKeyDown} onChange={(e) => handleSearchChange(e.target.value)} />
                        <button className='btn btn-outline-theme' onClick={() => clients(listParams)}>{t('Search')}</button>
                        <span onClick={() => handleClear()}>{t('Clear')}</span>
                        <div className='sort-filter'>
                            <SortOrFilterBox buttonName={'Filter'} filterBy={'Region'} showNotif={showNotif.filter} list={filterOption} handleShowNotif={() => showNotification('Filter')} handleApply={filterApply} />
                            <SortOrFilterBox buttonName={'Sort By'} filterBy={''} showNotif={showNotif.sort} list={sortOption} handleShowNotif={() => showNotification('Sort')} handleApply={sortApply} />
                        </div>
                    </div>

                    <div className='client-list'>
                        <table>
                            <thead>
                                <tr>
                                    <th>{t('Client ID')}</th>
                                    <th>{t('Username')}</th>
                                    <th>{t('Full name')}</th>
                                    <th>{t('Region')}</th>
                                    <th>{t('Account Manager')}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    activeClients?.map((activeClient) => (<>
                                        <tr>
                                            <td>{activeClient.clientId}</td>
                                            <td>{activeClient.userName}</td>
                                            <td>{activeClient.fullName}</td>
                                            <td>{activeClient.region}</td>
                                            <td>{activeClient.accountManager}</td>
                                            <td><button onClick={() => { preview(activeClient) }}>{t('Preview')}</button></td>
                                        </tr>
                                    </>))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='login-as-pagination'>
                        <Pagination
                            total={total}
                            showSizeChanger
                            showQuickJumper
                            pageSize={pageSize}
                            pageSizeOptions={[10, 20, 50, 100]}
                            onChange={(page, pageSize) => {
                                setPageNum(page);
                            }}
                            onShowSizeChange={(current, size) => {
                                setPageSize(size);
                            }}
                            showTotal={(total) => `${t('Total')} ${total} ${t('items')}`}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>);
}